<template>
  <span>
    <b-button @click.prevent="(e) => {e.target.blur();$bvModal.show('add-from-stock-modal')}"
                class="mr-1">Agregar desde linea</b-button>

    <b-modal id="add-from-stock-modal"
             size="xl">

      <stock-list :column_display="column_display"
                  :columns="columns"
                  :filterable="filterable"
                  :headings="headings"
                  :url="url"
                  @select-row="rowClick($event.id)"
                  @on-loading="loading=$event"/>

    </b-modal>

  </span>
</template>

<script>

  import StockList from '../../ServerFilterableTable'

  export default {
    name: "AddFromStock",
    components: {
      StockList
    },
    data() {
      return {
        loading: false,
        column_display: {
          product_family: 'not_desktop',
          product_fruit: 'not_desktop',
          lot: '',
          product_code: '',
          product: '',
          number: '',
          quantity: '',
          container: '',
          creation_date: 'not_desktop',
          net_kilograms: '',
          gross_kilograms: '',
          position: 'not_desktop',
        },
        columns: [
          "product_family",
          "product_fruit",
          "product_code",
          "product",
          "product_type.name",
          "lot",
          "stock_area",
          "number",
          "container",
          "quantity",
          "creation_date",
          "net_kilograms",
        ],
        filterable: [
          "product",
          "product_code",
          "product_type.name",
          "lot",
          "container",
          "creation_date",
          "stock_area",
          "number",
          "product_fruit",
          "product_family",
        ],
        headings: {
          product_family: "Familia",
          product_fruit: "Fruta",
          'product_type.name': "Tipo",
          lot: "Lote",
          number: "Número",
          product_code: "Código",
          product: "Producto",
          quantity: "Cantidad",
          container: "Recipiente",
          creation_date: "fecha",
          net_kilograms: "KN",
          gross_kilograms: "KB",
          stock_area: "Área",
        },
        // listColumns: {
        //   document_type: [
        //     {id: 0, text: 'Guia de despacho'},
        //     {id: 1, text: 'Factura'},
        //     {id: 2, text: 'Otro'},
        //   ]
        // },
      }
    },
    methods: {
      rowClick(evt) {
        this.$emit('row-click', evt)
      }
    },
    computed : {
      stock_area_filter_constructor() {
        let filter = this.$route.params;
        filter = !_.isEmpty(filter) ? filter.process_type_complete.stockarea_set.map(e => e.id).join("|stock_area=") : "";
        return 'stock_area='+filter;
      },
      url() {
        return '/bagno/content-stock/?'+this.stock_area_filter_constructor;
      }
    }
  }
</script>

<style scoped>

</style>
